import posthog from 'posthog-js'

// Initialize PostHog
posthog.init('phc_8V8ib7LJTGKG6478myqPyoNJp7J676DDpX79kxB9tS9', {
  api_host: 'https://tunnel.compress-glb.com',
  person_profiles: 'always',
  capture_pageview: true, // Ensure initial pageview is captured
  capture_pageleave: true, // Track when users leave pages
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('PostHog loaded')
    }
  }
})

export default posthog
